import { render, staticRenderFns } from "./RedemptionsList.vue?vue&type=template&id=21da7a11&"
import script from "./RedemptionsList.vue?vue&type=script&lang=ts&"
export * from "./RedemptionsList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports